import type { SafeMeta } from "./logging.types";

const SENSITIVE_TERMS = [
  "password",
  "pwd",
  "passwd",
  "token",
  "secret",
  "key",
  "api[_-]?key",
  "card",
  "credit",
  "cc[_-]?number",
  "ssn",
  "social[_-]?security",
  "authorization",
  "auth[_-]?token",
  "email",
  "e[_-]?mail",
  "phone",
  "phone[_-]?number",
  "mobile",
  "first[_-]?name",
  "last[_-]?name",
  "full[_-]?name",
  "name",
  "dob",
  "date[_-]?of[_-]?birth",
  "birth[_-]?date",
  "address",
  "zip",
  "postal",
].join("|");

const SENSITIVE_FIELD_PATTERN = new RegExp(SENSITIVE_TERMS, "i");

const SENSITIVE_INLINE_PATTERN = new RegExp(`(${SENSITIVE_TERMS})\\s*[:=]\\s*[^\\s,}]+`, "gi");

const redactMeta = (meta: SafeMeta): SafeMeta => {
  const out: SafeMeta = {};
  for (const [k, v] of Object.entries(meta)) {
    out[k] = SENSITIVE_FIELD_PATTERN.test(k) ? "[REDACTED]" : v;
  }
  return out;
};

const fmt = (event: string, meta?: SafeMeta): string => {
  const safeEvent = SENSITIVE_INLINE_PATTERN.test(event)
    ? event.replace(SENSITIVE_INLINE_PATTERN, "[REDACTED]")
    : event;
  const safeMeta = meta ? redactMeta(meta) : undefined;
  return JSON.stringify(safeMeta ? { event: safeEvent, meta: safeMeta } : { event: safeEvent });
};

const isProductionDeployment = process.env.VERCEL_ENV === "production";

const noop = () => {};

export const logger = {
  info: isProductionDeployment
    ? noop
    : (event: string, meta?: SafeMeta) => console.info(fmt(event, meta)),
  warn: (event: string, meta?: SafeMeta) => console.warn(fmt(event, meta)),
  error: (event: string, meta?: SafeMeta, error?: Error) =>
    console.error(fmt(event, meta), error ?? ""),
};
